
// Estrai i parametri dall'URL
function getUrlParams() {
        const searchParams = new URLSearchParams(window.location.search);
        const params = {};

        for (const [key, value] of searchParams) {
            params[key] = value;
        }

        return params;
}

// Funzione per impostare le opzioni selezionate nelle select
function setSelectValues() {
    (function($) {
        const urlParams = getUrlParams();
        const roleSelect = $('#people_role_select');
        const competenceSelect = $('#people_competence_area_select');
        const countrySelect = $('#people_country_select');

        if (urlParams['ruoloID']) {
            roleSelect.val(urlParams['ruoloID'].replace(/\/$/, '')).trigger('change');
        }

        if (urlParams['competenceID']) {
            competenceSelect.val(urlParams['competenceID'].replace(/\/$/, '')).trigger('change');
        }

        if (urlParams['countryID']) {
            countrySelect.val(urlParams['countryID'].replace(/\/$/, '')).trigger('change');
        }
        
    })(jQuery);
}

// Function for page load items
export function PeopleOnLoad(){
    (function($) {
        let window_size = $(window).width();
        let ruolo_id = null;
        let competence_id = null;
        let country_id = null;
        let competence_id_page = undefined;
        if($('.competence_area_peoples_block').data('competence')){
            competence_id_page = $('.competence_area_peoples_block').data('competence');
        }
        const urlParams = getUrlParams();

        if (urlParams['ruoloID'] !== undefined) {
            ruolo_id = urlParams['ruoloID'];
        }

        if (urlParams['competenceID'] !== undefined) {
            competence_id = urlParams['competenceID'];
        }else if(competence_id_page != undefined){
            competence_id = parseInt(competence_id_page);
        }

        if (urlParams['countryID'] !== undefined) {
            country_id = urlParams['countryID'].replace(/\/$/, '');
        }

        // Esegui la richiesta AJAX
        $.ajax({
            url: ajax_carousel_posts.ajax_url,
            type: 'post',
            data: {
                action: 'people_posts_onload',
                windowSize: window_size,
                ruoloID: ruolo_id,
                competenceID: competence_id,
                countryID: country_id,
            },
            success: function(response) {
                let htmlContent = response.html;
                let hasMorePosts = response.has_more_posts;

                $('#ajax_peoples_container_people_page').html(htmlContent);
                if(!hasMorePosts){
                    $("#more_people").hide();
                }
                setSelectValues();
                //setInterval(setSelectValues, 1000);
            },
            error: function(error) {
                console.log(error);
            }
        });

    })(jQuery);
}

let pageNumber = 1;
//Function for filtering
export function peopleListFiltering(){
    (function($) {
        function load_people(ruolo_id, competence_id, country_id, text_input){
            let window_size = $(window).width();
            pageNumber = 1;
            let str ='&ruoloID=' + ruolo_id + '&competenceID=' + competence_id + '&countryID=' + country_id + '&action=people_filters';
            $("#more_people").show();
            $.ajax({
                url: ajax_carousel_posts.ajax_url, // La variabile ajax_url è fornita da WordPress
                type: 'post',
                data: {
                    action: 'people_filters',
                    ruoloID: ruolo_id,
                    competenceID: competence_id,
                    countryID: country_id,
                    windowSize: window_size,
                    textInput: text_input,
                },
                success: function(response) {
                    // Accedi ai valori dalla risposta
                    let htmlContent = response.html;
                    let hasMorePosts = response.has_more_posts;

                    // Utilizza i valori come necessario
                    $('#ajax_peoples_container_people_page').html(htmlContent);
                    if(!hasMorePosts){
                        $("#more_people").hide();
                    }else{
                        $("#more_people").show();
                    }
                },
                error: function(error) {
                    console.log(error);
                }
            });
            return false;
        }

        //load_people();


        $('#people_role_select').on('change', function(){
            let ruolo = $('#people_role_select').val();
            let country = $('#people_country_select').val();
            let competence = $('#people_competence_area_select').val();
            let text_input = $('#custom_search_input_text').val();
            load_people(ruolo, competence, country, text_input);
        })

        $("#people_competence_area_select").on('change', function(){
            let ruolo = $('#people_role_select').val();
            let country = $('#people_country_select').val();
            let competence = $('#people_competence_area_select').val();
            let text_input = $('#custom_search_input_text').val();
            load_people(ruolo, competence, country, text_input);
        })

        $("#people_country_select").on('change', function(){
            let ruolo = $('#people_role_select').val();
            let country = $('#people_country_select').val();
            let competence = $('#people_competence_area_select').val();
            let text_input = $('#custom_search_input_text').val();
            load_people(ruolo, competence, country, text_input);
        })

        $("#custom_search_input_text").on('input', function(){
            let ruolo = $('#people_role_select').val();
            let country = $('#people_country_select').val();
            let competence = $('#people_competence_area_select').val();
            let text_input = $('#custom_search_input_text').val();
            load_people(ruolo, competence, country, text_input);

        })

        $('#reset_action').on('click', function(){
            load_people(null, null, null);
            $('#people_role_select').val(null).trigger('change');
            $('#people_country_select').val(null).trigger('change');
            $('#people_competence_area_select').val(null).trigger('change');
            $('#custom_search_input_text').val(null);
        })

    })(jQuery);
}

//Function for load more of listing items
export function AjaxLoadPeople(){
    (function($) {
        let window_size = $(window).width();
        let ppp = 4;// Post per page
        //let pageNumber = 1;
        
        function load_posts_people(ruolo_id, competence_id, country_id, text_input){
            pageNumber++;
            $('p#loading_text').show();
            $("#more_people").hide();
            $.ajax({
                type: "POST",
                dataType: "html",
                url: ajax_posts.ajaxurl,
                data: {
                    action: 'more_people_ajax',
                    ruoloID: ruolo_id,
                    competenceID: competence_id,
                    countryID: country_id,
                    windowSize: window_size,
                    pageNumber: pageNumber,
                    textInput: text_input,
                    ppp: ppp
                },
                success: function(data){
                    let response = JSON.parse(data);
                    let html = response.html;
                    let has_more_posts = response.has_more_posts;
                    let $data = $(html);
                    if($data.length){
                        $("#ajax_content_our_people").append($data);
                        $('p#loading_text').hide();
                        $("#more_people").show();
                        if (has_more_posts) {
                            $("#more_people").attr("disabled", false);
                        } else {
                            $("#more_people").hide();
                            if($('#all_people_link_competence').length > 0){
                                $('#all_people_link_competence').css('display', 'flex');
                            }
                        }
                        //$("#more_people").attr("disabled",false); // Uncomment this if you want to disable the button once all posts are loaded
                    }else{
                        $("#more_people").hide(); // This will hide the button once all posts have been loaded
                        $('p#loading_text').hide();
                        if($('#all_people_link_competence').length > 0){
                            $('#all_people_link_competence').css('display', 'flex');
                        }
                    }
                },
                error : function(jqXHR, textStatus, errorThrown) {
                    //$loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
                }
        
            });
            return false;
        }
        
        $("#more_people").on("click",function(e){ // When btn is pressed.
            e.preventDefault();
            //$("#more_posts").text('Caricamento..'); // Disable the button, temp.
            let ruolo = $('#people_role_select').val();
            let country = $('#people_country_select').val();
            let text_input = $('#custom_search_input_text').val();
            let competence = undefined;
            if($('.competence_area_peoples_block').data('competence')){
                competence = $('.competence_area_peoples_block').data('competence');
            }else{
                competence = $('#people_competence_area_select').val();
            }
            load_posts_people(ruolo, competence, country, text_input);
        });
    })(jQuery);
}
